<template>
  <div class="shows">
    <h1><span class="resize" style="cursor:pointer" @click="back">&lt;&nbsp;</span>{{showName}} - {{seasonName}}</h1>
    <div class="data">
      <div v-for="episode in episodes" :key="episode.name" class="panel show" @click="open(episode)">
        {{episode.name}}
      </div>
    </div>
  </div>
</template>

<script>

import config from '../config';

export default {
  name: 'Episodes',
  data() {
    return {
      episodes: [],
      showName: this.$route.params.showName,
      seasonName: this.$route.params.seasonName
    }
  },
  methods: {
    open(episode) {
      this.$router.push(`/watch/${episode.fileId}`)
    },
    back() {
      this.$router.push(`/seasons/${this.showName}`)
    },
    getEpisodes() {
      const password = localStorage.getItem('password');
      const authorization = localStorage.getItem('authorization');

      this.axios.get(`${config.api}/episodes/${this.showName}/${this.seasonName}`, {
        headers: {
          password,
          authorization
        }
      })
      .then(result => {
        this.episodes = result.data;
      })
    }
  },
  created() {
    this.getEpisodes();
  }
}
</script>

<style scoped>

.show {
  width: 100px;
  height: 100px;

  transition: 200ms;

  transform: scale(1);

  cursor: pointer;

  margin: 5px;
}

.show:hover {
  transform: scale(1.1);
}

.data {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Episodes.vue